/**
 * Skip to Content Link
 * Phase 5.3.1: WCAG 2.1 AA Accessibility
 *
 * Provides keyboard users a way to skip navigation and jump directly to main content.
 * The link is visually hidden but becomes visible when focused.
 */

interface SkipToContentProps {
  targetId: string;
  label?: string;
}

export function SkipToContent({ targetId, label = 'Skip to main content' }: SkipToContentProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const target = document.getElementById(targetId);
    if (target) {
      target.focus();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <a
      href={`#${targetId}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:m-4 focus:rounded-md focus:bg-primary focus:px-4 focus:py-2 focus:text-primary-foreground focus:shadow-lg focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2"
    >
      {label}
    </a>
  );
}
